import * as constants from './constants';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const setsReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_SETS:
    return { ...state, loading: true };
  case constants.GET_SETS_SUCCESS:
    return { ...state, loading: false, data: action.payload };
  case constants.GET_SETS_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.CLEAR_SETS:
    return initialState;
  default:
    return state;
  }
};
